import { formatDateTime } from 'utils/util'
import { type Sweepstake } from '../../../types/api'
import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import { SectionHeaderButton } from 'components/Sweepstakes/SectionHeaderButton'

export const SweepstakesDetailsSection = ({
  sweepstake,
}: {
  sweepstake: Sweepstake
}) => {
  // Adjusting the breakpoint to 900px to better accommodate the content and layout of the Location Sweepstakes Details section, ensuring a more responsive design across various devices.
  const isMobile = useMediaQuery('(max-width: 900px)')

  return (
    <>
      <SectionHeaderButton titleText="Sweepstakes Overview" />
      <Box
        sx={{
          borderWidth: 1,
          borderColor: 'grey.300',
          borderRadius: 2,
          p: '16px',
          mb: '40px',
          mt: '15px',
        }}
      >
        <Grid
          container
          sx={{ rowGap: isMobile ? 4 : 5, columnGap: isMobile ? 20 : 0 }}
        >
          <Grid item md={4} sm={6}>
            <Typography variant="body-2" color="text.secondary">
              Sweepstakes Name
            </Typography>
            <Typography variant="body-1" color="text.primary">
              {sweepstake.name}
            </Typography>
          </Grid>
          <Grid
            container
            sx={{
              rowGap: isMobile ? 4 : 6,
              columnGap: isMobile ? '35%' : '5%',
            }}
          >
            <Grid item md={4} sm={6}>
              <Typography variant="body-2" color="text.secondary">
                Start Date
              </Typography>
              <Typography variant="body-1" color="text.primary">
                {formatDateTime(sweepstake.startDate, 'P p')}
              </Typography>
            </Grid>
            <Grid item md={4} sm={6}>
              <Typography variant="body-2" color="text.secondary">
                End Date
              </Typography>
              <Typography variant="body-1" color="text.primary">
                {formatDateTime(sweepstake.endDate, 'P p')}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              rowGap: isMobile ? 4 : 6,
              columnGap: isMobile ? '50%' : '5%',
            }}
          >
            <Grid item md={4} sm={4}>
              <Typography variant="body-2" color="text.secondary">
                URL
              </Typography>
              <Typography variant="body-1" color="text.primary">
                {sweepstake.url}
              </Typography>
            </Grid>
            <Grid item md={4}>
              <Typography variant="body-2" color="text.secondary">
                Sweepstakes Description
              </Typography>
              <Typography variant="body-1" color="text.primary">
                {sweepstake.description}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
